import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import { useState } from "preact/hooks"

export default function Serp() {
    const {
        response: { products },
        loading
    } = useAppState()
    const foundProducts = products && products.total > 0
    const toggleButtonId = "toggle-mobile-sidebar"
    const [sidebarOpen, setSidebarOpen] = useState(false);

    function toggleSidebar(){
        setSidebarOpen((currentState)=>!currentState)

        if(document.body.classList.contains('ns-noscroll')){
            document.body.classList.remove('ns-noscroll')
        } else {
            document.body.classList.add('ns-noscroll')
        }
    }

    return (
        <div
            class={`ns-serp ${location.pathname.indexOf('/collections') > -1 ? 'ns-category-page' : ''} ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-mx-auto`}
            data-nosto-element="search"
        >
            {(foundProducts || (loading && foundProducts)) && <Sidebar toggleId={toggleButtonId} onToggleSidebar={toggleSidebar} isActive={sidebarOpen} />}
            <div
                class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0"
                style={loading ? "position: relative;" : ""}
            >                
                {foundProducts ? (
                    <>
                        <h1 class="ns-pl-3">Search results</h1>
                        <Toolbar lableFor={toggleButtonId} onToggleSidebar={toggleSidebar} isSearch={true} />
                        <Products />
                        <BottomToolbar />
                    </>
                ) : !loading ? (
                    <NoResults />
                ) : ''}

                {/* To enable InfiniteScroll - comment above block and uncomment below.
                    Don't forget to import InfiniteScroll component. */}
                {/* {foundProducts ? (
                    <>
                        <SelectedFilters />
                        <Toolbar />
                        <InfiniteScroll>
                            <Products />
                        </InfiniteScroll>
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )} */}
            </div>
        </div>
    )
}
